import { Component } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { LoadingService } from './services/loading.service';
import { LoadingComponent } from './shared/loading/loading.component';

@Component({
  selector: 'mat-root',
  standalone: true,
  imports: [RouterLink, RouterOutlet, LoadingComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  // Directly access the signal from the service
  constructor(
    public loadingService: LoadingService,
    private router: Router,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // Show full-page loader on route change start
        this.loadingService.showFullPageLoader();
      }
      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        // Hide full-page loader on route change end
        this.loadingService.hideFullPageLoader();
      }
    });
  }
}
